import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { LoteCertificado } from 'src/app/models/LoteCertificado.model';

@Injectable({
  providedIn: 'root'
})
export class LoteCertificadoService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'lotes'); // La URL base para el servicio de lotes
  }

  indexLoteCertificado(loteId: number) {
    return this.get<LoteCertificado[]>({
      endpoint: `${loteId}/certificados`,
      trackLoading: true     // 👈 activa el loader
    });
  }

  indexLoteCertificadoGrupo(loteId: number) {
    return this.get<any>({
      endpoint: `${loteId}/certificados/grupos`,
      trackLoading: true     // 👈 activa el loader
    });
  }

  putLoteCertificado(payload: any, loteId: number, certificadoId: string) {
    return this.put<any>(
      payload,
      `${loteId}/certificados/${certificadoId}`,
      undefined,
      true                   // 👈 activa el loader
    );
  }

  firmarConImagen(payload: any, loteId: number) {
    return this.put<any>(
      payload,
      `/certificados/${loteId}/firmas/imagenes`,
      undefined,
      true                   // 👈 activa el loader
    );
  }

  deleteCertificado(loteId: number, certificadoId: number) {
    return this.delete<any>(`${loteId}/certificados/${certificadoId}`);
  }

  deleteGrupoCertificado(loteId: number, grupoId: number) {
    return this.delete<any>(`${loteId}/certificados/grupos/${grupoId}`);
  }

  putCertificado(payload: any, id_lote_certificado: number) {
    return this.put<any>(
      payload,
      `/certificados/${id_lote_certificado}`,
      undefined,
      true                   // 👈 activa el loader
    );
  }

  loteCertificado(loteId: number, id_certificado: number) {
    return this.get<any>({
      endpoint: `${loteId}/certificados/${id_certificado}`,
      trackLoading: true    
    });
  }

  putLoteCertificadoEstado(payload: any, id_lote_certificado: number) {
    return this.put<any>(payload,`/certificados/${id_lote_certificado}/estados`,undefined,true                   // 👈 activa el loader
    );
  }

  notificaciones(loteId: any) {
      return this.post<any>([], `/${loteId}/notificaciones/enviar`);
  }

  
  postLotesCertificados(data:any ,   loteId: any) {
      return this.post<any>(data , `/${loteId}/certificados`);
  }

}